import MaintenanceWorkflowForwardingCheckinEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckinEntry'
import MaintenanceWorkflowForwardingCheckoutEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckoutEntry'
import MaintenanceWorkflowForwardingDirectiveEntrySectionDiagnosticEntry from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/DirectiveEntry/Entries/DiagnosticEntry'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry'
import MaintenanceWorkflowForwardingActions from '../../../Sections/ForwardingActions'

const DiagnosticEntryOnGoingCheckout = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingActions />

      <MaintenanceWorkflowForwardingCheckoutEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntrySectionDiagnosticEntry />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  )
}

export default DiagnosticEntryOnGoingCheckout
